import React from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import { set } from 'lodash';
import { ElementTemplate } from '../../../../DevlopmentOrder/PurchaseOrder/TemplateComponent';
import { usePOrderDetailState } from '../PODetailProvider';
import { commonPath } from '../../../../DevlopmentOrder/PurchaseOrder/fieldPath';

function RenderShippingDetails({ data, pIndex }) {
  const { poDetailstate, setPoDetailState, disablePoCondition } = usePOrderDetailState();
  const handleChange = async (value, keyName) => {
    const copyState = poDetailstate;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    if (locate[0]?.startsWith(`templateJsonSchema[${pIndex}].columns[0][0]`)) {
      copyState.templateJsonSchema[pIndex].columns[1][0].value = value?.email;
      if (copyState.templateJsonSchema[pIndex].columns[1][0].hasError) {
        copyState.templateJsonSchema[pIndex].columns[1][0].hasError.status = false;
      }
    }
    set(poDetailstate, `${locate[0]}.hasError.status`, false);
    await set(poDetailstate, keyName, value);
    await setPoDetailState((prevState) => ({
      ...prevState,
      ...copyState,
    }));
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns.map((column, index) => {
            return (
              <Col lg={6} key={column?.label}>
                {column.map((col, i) => {
                  return (
                    col?.enable && (
                      <FormGroup key={col?.id}>
                        <ElementTemplate
                          {...col}
                          keys={col?.key}
                          onChange={handleChange}
                          error={col?.hasError}
                          requiredField={col?.required}
                          value={col?.value}
                          disable={disablePoCondition}
                          path={
                            col?.key === 'Check_Boxes' ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX : commonPath(pIndex, index, i).COMPANY_DETAILS
                          }
                        />
                      </FormGroup>
                    )
                  );
                })}
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderShippingDetails;
